import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import miraiLogo from "../../assest/mirai-logo.png";
import axios from "axios";

const FooterMirai = () => {
  const [services, setServices] = useState([]); // State to store services
  const [loading, setLoading] = useState(true); // State for loading indicator

  useEffect(() => {
    // Fetch services data
    const fetchServices = async () => {
      try {
        const response = await axios.get("https://mirai-server.vercel.app/service-main");
        setServices(response.data); // Update state with fetched data
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.error("Error fetching services:", error);
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  const globalWebsite = [
    {
      id: "1",
      link: "https://miraic-global.jp/china/",
      title: "China (Shanghai/Beijing/Shenzhen)",
    },
    {
      id: "2",
      link: "https://miraic-global.jp/vietnam/",
      title: "Vietnam (Ho Chi Minh/Hanoi)",
    },
    {
      id: "3",
      link: "https://miraic-global.jp/malaysia/",
      title: "Malaysia",
    },
    {
      id: "4",
      link: "https://miraic-global.jp/singapore/",
      title: "Singapore",
    },
    {
      id: "5",
      link: "https://miraic-global.jp/thailand/",
      title: "Thailand",
    },
  ];
  return (
    <div className="bg-gray-900 text-white">
  {/* Desktop Footer */}
  <div className="hidden lg:block">
    <div className="max-w-screen-2xl mx-auto px-4 py-12">
      <div className="grid lg:grid-cols-4 grid-cols-1  lg:gap-8 gap-4">
        {/* Company Info */}
        <div>
          <Link to="/" className="flex items-center space-x-3">
            <h1 className="text-2xl font-semibold font-jost">
              MIRAI Consulting Bangladesh Ltd.
            </h1>
          </Link>
          <div className="mt-6 space-y-3">
            <p className="text-gray-300 font-jost">
              TEL: (880)-161-5351769
            </p>
            <p className="text-gray-300 text-sm font-jost">
              Bari Momen's Heights, Plot-157, Flat 9A, Road-12, Block-E, Banani, Dhaka-1213, Bangladesh
            </p>
            <div className="pt-2">
              <a href="https://www.linkedin.com/company/mirai-consulting-group/" target="_blank" rel="noopener noreferrer">
                <img
                  className="w-8 h-8 hover:opacity-80 transition-opacity"
                  alt="LinkedIn"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTc2IDE3NiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48cmVjdCB3aWR0aD0iMTc2IiBoZWlnaHQ9IjE3NiIgZmlsbD0iIzAwNzdiNSIgcng9IjI0IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDA3N2I1Ij48L3JlY3Q+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTYzLjQgNDhhMTUgMTUgMCAxIDEtMTUtMTUgMTUgMTUgMCAwIDEgMTUgMTV6TTYwIDczdjY2LjI3YTMuNzEgMy43MSAwIDAgMS0zLjcxIDMuNzNINDAuNDhhMy43MSAzLjcxIDAgMCAxLTMuNzItMy43MlY3M2EzLjcyIDMuNzIgMCAwIDEgMy43Mi0zLjcyaDE1LjgxQTMuNzIgMy43MiAwIDAgMSA2MCA3M3pNMTQyLjY0IDEwNy41djMyLjA4YTMuNDEgMy40MSAwIDAgMS0zLjQyIDMuNDJoLTE3YTMuNDEgMy40MSAwIDAgMS0zLjQyLTMuNDJ2LTMxLjA5YzAtNC42NCAxLjM2LTIwLjMyLTEyLjEzLTIwLjMyLTEwLjQ1IDAtMTIuNTggMTAuNzMtMTMgMTUuNTV2MzUuODZBMy40MiAzLjQyIDAgMCAxIDkwLjMgMTQzSDczLjg4YTMuNDEgMy40MSAwIDAgMS0zLjQxLTMuNDJWNzIuNzFhMy40MSAzLjQxIDAgMCAxIDMuNDEtMy40Mkg5MC4zYTMuNDIgMy40MiAwIDAgMSAzLjQyIDMuNDJ2NS43OGMzLjg4LTUuODIgOS42My0xMC4zMSAyMS45LTEwLjMxIDI3LjE4IDAgMjcuMDIgMjUuMzggMjcuMDIgMzkuMzJ6Ij48L3BhdGg+PC9nPjwvZz48L2c+PC9zdmc+"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Explore */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Explore</h2>
          <ul className="space-y-3">
            <li>
              <Link to="/career" className="font-jost hover:text-blue-500 transition-colors">
                Career
              </Link>
            </li>
            <li>
              <Link to="/gallery" className="font-jost hover:text-blue-500 transition-colors">
                News
              </Link>
            </li>
            <li>
              <Link to="/consultation" className="font-jost hover:text-blue-500 transition-colors">
                Free consulting
              </Link>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Services</h2>
          <ul className="space-y-2">
            {services.map((service) => (
              <li key={service._id}>
                <Link 
                  to={`/service/${service._id}`} 
                  className="font-jost hover:text-blue-500 transition-colors"
                >
                  {service.service}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Branches */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Headquarter</h2>
          <a 
            href="https://www.miraic.jp/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="font-jost hover:text-blue-500 transition-colors"
          >
            Tokyo
          </a>

          <h2 className="text-xl font-semibold mt-6 mb-4">Overseas Branches</h2>
          <ul className="space-y-2">
            {globalWebsite.map((branch) => (
              <li key={branch.title}>
                <a 
                  href={branch.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="font-jost hover:text-blue-500 transition-colors"
                >
                  {branch.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800 mt-12 pt-6">
        <p className="text-gray-400 font-jost">
          © {new Date().getFullYear()} MIRAI Consulting Bangladesh Ltd. All rights reserved.
        </p>
      </div>
    </div>
  </div>

  {/* Mobile Footer */}
  <div className="lg:hidden px-4 py-8">
    <div className="space-y-8">
      {/* Company Info */}
      <div>
        <Link to="/" className="flex items-center space-x-3">
          <h1 className="text-xl font-semibold font-jost">
            MIRAI Consulting Bangladesh Ltd.
          </h1>
        </Link>
        <div className="mt-4 space-y-2">
          <p className="text-gray-300 font-jost">
            TEL: (880)-161-5351769
          </p>
          <p className="text-gray-300 text-sm font-jost">
            Bari Momen's Heights, Plot-157, Flat 9A, Road-12, Block-E, Banani, Dhaka-1213, Bangladesh
          </p>
          <div className="pt-2">
            <a href="https://www.linkedin.com/company/mirai-consulting-group/" target="_blank" rel="noopener noreferrer">
              <img
                className="w-8 h-8 hover:opacity-80 transition-opacity"
                alt="LinkedIn"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTc2IDE3NiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48cmVjdCB3aWR0aD0iMTc2IiBoZWlnaHQ9IjE3NiIgZmlsbD0iIzAwNzdiNSIgcng9IjI0IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDA3N2I1Ij48L3JlY3Q+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTYzLjQgNDhhMTUgMTUgMCAxIDEtMTUtMTUgMTUgMTUgMCAwIDEgMTUgMTV6TTYwIDczdjY2LjI3YTMuNzEgMy43MSAwIDAgMS0zLjcxIDMuNzNINDAuNDhhMy43MSAzLjcxIDAgMCAxLTMuNzItMy43MlY3M2EzLjcyIDMuNzIgMCAwIDEgMy43Mi0zLjcyaDE1LjgxQTMuNzIgMy43MiAwIDAgMSA2MCA3M3pNMTQyLjY0IDEwNy41djMyLjA4YTMuNDEgMy40MSAwIDAgMS0zLjQyIDMuNDJoLTE3YTMuNDEgMy40MSAwIDAgMS0zLjQyLTMuNDJ2LTMxLjA5YzAtNC42NCAxLjM2LTIwLjMyLTEyLjEzLTIwLjMyLTEwLjQ1IDAtMTIuNTggMTAuNzMtMTMgMTUuNTV2MzUuODZBMy40MiAzLjQyIDAgMCAxIDkwLjMgMTQzSDczLjg4YTMuNDEgMy40MSAwIDAgMS0zLjQxLTMuNDJWNzIuNzFhMy40MSAzLjQxIDAgMCAxIDMuNDEtMy40Mkg5MC4zYTMuNDIgMy40MiAwIDAgMSAzLjQyIDMuNDJ2NS43OGMzLjg4LTUuODIgOS42My0xMC4zMSAyMS45LTEwLjMxIDI3LjE4IDAgMjcuMDIgMjUuMzggMjcuMDIgMzkuMzJ6Ij48L3BhdGg+PC9nPjwvZz48L2c+PC9zdmc+"
              />
            </a>
          </div>
        </div>
      </div>
         {/* Services (full width on mobile) */}
      <div>
        <h3 className="text-lg font-semibold mb-3">Services</h3>
        <div className="grid grid-cols-1 gap-2">
          {services.map((service) => (
            <div key={service._id}>
              <Link 
                to={`/service/${service._id}`} 
                className="text-sm font-jost hover:text-blue-500 transition-colors"
              >
                {service.service}
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile Grid */}
      <div className="grid grid-cols-1 gap-6">
        {/* Explore */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Explore</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/career" className="text-sm font-jost hover:text-blue-500 transition-colors">
                Career
              </Link>
            </li>
            <li>
              <Link to="/gallery" className="text-sm font-jost hover:text-blue-500 transition-colors">
                News
              </Link>
            </li>
            <li>
              <Link to="/consultation" className="text-sm font-jost hover:text-blue-500 transition-colors">
                Free consulting
              </Link>
            </li>
          </ul>
        </div>

        {/* Branches */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Headquarter</h3>
          <a 
            href="https://www.miraic.jp/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm font-jost hover:text-blue-500 transition-colors"
          >
            Tokyo
          </a>

          <h3 className="text-lg font-semibold mt-4 mb-3">Overseas Branches</h3>
          <ul className="space-y-2">
            {globalWebsite.map((branch) => (
              <li key={branch.title}>
                <a 
                  href={branch.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm font-jost hover:text-blue-500 transition-colors"
                >
                  {branch.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

   

      {/* Copyright */}
      <div className="border-t border-gray-800 pt-6 mt-6">
        <p className="text-gray-400 text-sm font-jost">
          © {new Date().getFullYear()} MIRAI Consulting Bangladesh Ltd. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</div>
  );
};

export default FooterMirai;
